import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ActionButton from 'components/common/ActionButton';
import PageHeader from 'components/common/PageHeader';

const ListUpcomingEvents = () => {
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/upcoming-events/list`
        );

        console.log(response.data);
        setUpcomingEvents(response.data);
      } catch (error) {
        console.log('error', error);
        setError(error.message);
      } finally {
        console.log('finally');
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const archiveEvent = async (id, title) => {
    if (
      window.confirm(`Are you sure you want to delete this event: ${title}?`)
    ) {
      try {
        setError(null);
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/upcoming-events/archive/id/${id}`
        );
        console.log(response.data);
        setUpcomingEvents(upcomingEvents.filter((event) => event.id !== id));
      } catch (error) {
        console.log('error', error);
        setError(error.message);
      }
    }
  };

  return (
    <>
      <PageHeader
        title='Upcoming Events'
        description=''
        className='mb-3'
      ></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : (
        <Table hover responsive>
          <thead>
            <tr>
              <th scope='col'>Title</th>
              <th scope='col'>Post date</th>
              <th className='text-end' scope='col'>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {upcomingEvents.map((event, index) => (
              <tr key={index}>
                <td>{event.title}</td>
                <td>{event.start_date}</td>
                <td className='text-end'>
                  <Link to={`/upcoming-events/edit/${event.id}`}>
                    <ActionButton
                      icon='edit'
                      title='Edit'
                      variant='action'
                      className='p-0 me-2'
                      alt='Edit'
                    />
                  </Link>
                  <ActionButton
                    icon='trash-alt'
                    title='Delete'
                    variant='action'
                    className='p-0'
                    alt='Delete'
                    onClick={() => archiveEvent(event.id, event.title)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default ListUpcomingEvents;
